export function isValidationError(result) {
    const { valid, empty } = result;
    return !empty && !valid;
}
export function showValidationError(t, result, force, i18n, i18nVariables, i18nPrefix = 'cms:') {
    const { errors } = result;
    if ((isValidationError(result) || force) && errors.length > 0) {
        if (result.backendError)
            return errors.join(' ');
        return i18n && i18n.length > 0 // TODO: join multiple errors
            ? t(`${i18nPrefix}${i18n}.error.${errors[0]}`, i18nVariables ?? {})
            : t(errors[0]);
    }
    return undefined;
}
